import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { shouldRedirectFromExecutiveDashboard } from '../../constants/deliveryCockpitNav';
import { isPublicRouteEdition } from '../../constants/psaRouteEdition';
import {
    getPublicEditionDeferredRouteMode,
    hasExecutiveDashboardAccess,
} from '../../utils/deferredRouteAccess';
import { DeliveryCockpitEditionBlocked } from './DeliveryCockpitEditionBlocked';
import AppRouteNotFound from './AppRouteNotFound';

/**
 * Gates executive KPI dashboards (/executive-dashboard, /overview-dashboard).
 *
 * @param {object} props
 * @param {React.ReactNode} props.children - Executive dashboard content.
 * @param {string} [props.featureName] - User-facing feature label (develop builds only).
 */
const ExecutiveDashboardRouteGuard = ({
    children,
    featureName = 'Executive dashboard',
}) => {
    const { user, loading } = useAuth();

    if (loading) {
        return null;
    }

    if (isPublicRouteEdition()) {
        if (getPublicEditionDeferredRouteMode(user) === 'edition-blocked') {
            return <DeliveryCockpitEditionBlocked featureName={featureName} />;
        }
        return <AppRouteNotFound />;
    }

    if (hasExecutiveDashboardAccess(user)) {
        return children;
    }

    if (shouldRedirectFromExecutiveDashboard(user?.role)) {
        return <Navigate to="/project-operations" replace />;
    }

    return <DeliveryCockpitEditionBlocked featureName={featureName} />;
};

export default ExecutiveDashboardRouteGuard;
